import * as React from 'react';
import {
  DragDropContext,
  Droppable,
  OnDragEndResponder
} from 'react-beautiful-dnd';
import DraggableListItem, { Item } from './DraggableListItem';

export type DraggableListProps = {
  items: Item[];
  onDragEnd: OnDragEndResponder;
  imageClassName?: string;
};


const DraggableList = React.memo(({ items, onDragEnd, imageClassName }: DraggableListProps) => {
  return (
    <DragDropContext onDragEnd={onDragEnd}>
      <Droppable droppableId="droppable-list">
        {provided => (
          <div ref={provided.innerRef} {...provided.droppableProps}>
            {items.map((item, index) => (
              <DraggableListItem item={item} index={index} key={item.id} cName={imageClassName}/>
            ))}
            {provided.placeholder}
          </div>
        )}
      </Droppable>
    </DragDropContext>
  );
});

export default DraggableList;
